/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { isNone, isEmpty } from '@ember/utils';
import COLOR_LABELS from 'cio/utils/color-labels';
import actionInfo from 'cio/utils/action-info';
import afterRender from 'cio/utils/after-render';
import itemProperty from '@customerio/fly-components/utils/item-property';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class PowerSelectDeliveryMenuItem extends Component {
  fullLabelWidth = null;
  fullDetailWidth = null;
  hover = false;
  labelProperty = null;
  container = null;

  @computed('labelProperty')
  get _labelProperty() {
    return this.labelProperty ?? 'subject';
  }

  @computed('item', '_labelProperty')
  get label() {
    if (this.item.parent?.type === 'transactional message') {
      return this.item.parent?.name;
    }

    return itemProperty(this.item, this._labelProperty);
  }

  @computed('item.type')
  get actionInfo() {
    return actionInfo(`${this.item.type}_action`);
  }

  @computed('item.variation')
  get variationLabel() {
    let { variation } = this.item;

    if (isNone(variation)) {
      return;
    }

    return COLOR_LABELS[variation - 1];
  }

  @computed('item.{variation,language}')
  get languageLabel() {
    let { language } = this.item;

    if (isNone(language)) {
      return;
    }

    return isEmpty(language) ? 'Default' : language;
  }

  @computed('hover')
  get labelTransformStyle() {
    return this.hover ? `transform: translateX(calc(100% - ${this.fullLabelWidth}px));` : '';
  }

  @computed('hover')
  get detailTransformStyle() {
    return this.hover ? `transform: translateX(calc(100% - ${this.fullDetailWidth}px));` : '';
  }

  @action
  setElement(el) {
    this.set('container', el);
  }

  @action
  handleMouseEnter() {
    this.set('hover', true);
  }

  @action
  handleMouseLeave() {
    this.set('hover', false);
  }

  _setContentWidthProperties() {
    this.set('fullLabelWidth', this.container.querySelector('.js-delivery-menu-item-label').scrollWidth);

    let detailElement = this.container.querySelector('.js-delivery-menu-item-detail');
    if (detailElement) {
      this.set('fullDetailWidth', detailElement.scrollWidth);
    }
  }

  didInsertElement() {
    super.didInsertElement(...arguments);

    afterRender(() => this._setContentWidthProperties());
  }
}
